module.exports = __webpack_public_path__ + "static/media/办公楼楼宇智能化管理3.35307af7.jpg";